export default {
      id: "Icon_No Visible-usage",
      viewBox: "0 0 19 17",
      url: __webpack_public_path__ + "img/icons.svg#Icon_No Visible",
      toString: function () {
        return this.url;
      }
    }